import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, makeStyles } from '@material-ui/core';
import { formattingDigitCurrency } from 'utils';
import { DetailProductLine } from 'Components/Ticket/Product';

import { useAtom } from 'jotai';
import {
  shareNoteAtom,
  listProductsSelectedToPayAtom,
  stepPaymentTicketAtom,
  sendRequestForPaymentAtom,
} from 'Atoms/Ticket';

const useStyles = makeStyles((theme) => ({
  listItem: {
    background: 'white',
    minHeight: '55px',
    margin: '5px 0',
    padding: '1rem',
  },
  title: { ...theme.title, margin: '1rem 0 .5rem 1rem' },
}));
const ListProductsSelected = ({
  listProducts,
  myPartToPaid,

  setMyPartToPaid,
}) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const sections = listProducts;
  const [shareNote, setShareNote] = useAtom(shareNoteAtom);
  /*  const [stepPaymentTicket, setStepPaymentTicket] = useAtom(
    stepPaymentTicketAtom,
  ) */

  const [productSelected, setProductSelected] = useAtom(
    listProductsSelectedToPayAtom,
  );
  const action = {
    name: 'selected',
  };

  useEffect(() => {
    if (shareNote && shareNote.selected !== 'perProduct') {
      setShareNote({ selected: 'perProduct', value: productSelected });
    }
  }, []);

  const handleSetItemSelected = (product, addProduct) => {
    const { idCheckbox } = product;
    const newListProductSelected = addProduct
      ? addNewProduct(product)
      : removeProduct(productSelected, idCheckbox, product);

    setShareNote({ ...shareNote, value: newListProductSelected });
    setProductSelected(newListProductSelected);
  };

  const removeProduct = (products, idCheckbox, product) => {
    handleMyPartToPaid(product, '-');
    return products.filter(
      (itemProduct) => itemProduct.idCheckbox !== idCheckbox,
    );
  };

  const addNewProduct = (product) => {
    const newProductSelected = [...productSelected];
    handleMyPartToPaid(product, '+');

    return [...newProductSelected, product];
  };

  const handleMyPartToPaid = (product, operator) => {
    const { amount, quantity } = myPartToPaid;
    const mathOperator = {
      '-': function (x, y) {
        return x - y;
      },
      '+': function (x, y) {
        return x + y;
      },
    };
    const totalProductsWithSublines = calTotalProductsWithSublines(product);
    const newAmount = mathOperator[operator](amount, totalProductsWithSublines);
    const newQuantity = mathOperator[operator](quantity, product.quantity);
    const formattingNewAmount =
      typeof newAmount === 'number'
        ? newAmount.toFixed(2)
        : parseFloat(newAmount).toFixed(2);

    setMyPartToPaid({
      amount: parseFloat(formattingNewAmount),
      quantity: newQuantity,
    });
  };

  const calTotalProductsWithSublines = (product) => {
    let amount = product?.price ? product.price : 0;
    product?.sublines &&
      product.sublines.map((subline) => (amount += subline.price));
    return amount;
  };

  return (
    <Grid container>
      <Typography className={classes.title}>
        {t('select_your_products')}
        {t('space-colon')}
      </Typography>
      {sections.map((section, id) => {
        return (
          <Grid item xs={12} key={`section-${section.id}-${id}`}>
            <Grid container direction="row" key={`grid-${section.id}-${id}`}>
              {section.lines.map((line) => {
                return Array.apply(null, new Array(line.nb)).map(
                  (product, i) => (
                    <Grid
                      item
                      xs={12}
                      key={`${line.id}-${line.uiId ? line.uiId : ''}`}
                      className={classes.listItem}
                    >
                      <DetailProductLine
                        action={action}
                        label={line.label}
                        idProduct={line.id}
                        idCheckbox={`${line.id}-${line.uiId ? line.uiId : ''}`}
                        price={line.price}
                        quantity={line.nb}
                        offered={line.offered}
                        productSelected={productSelected}
                        idSection={line.idSection}
                        handleSetItemSelected={handleSetItemSelected}
                        sublines={line.sublines}
                        priceBeforeDiscount={line.priceBeforeDiscount}
                        pricePaid={line.pricePaid}
                      />
                    </Grid>
                  ),
                );
              })}
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};

ListProductsSelected.propTypes = {
  listProducts: PropTypes.array.isRequired,
  currency: PropTypes.shape({
    countryCode: PropTypes.string.isRequired,
    labelCode: PropTypes.string.isRequired,
  }),
};

export default ListProductsSelected;
